import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IParentTimetableQueryParams,
  IParentTimetableResponse,
} from '../../interface/parentTimetable.interface';
import { IErrorResponse } from '../../interface/main.interface';
import { parentTimetableService } from '../../services/parentTimetable';
import { normalizeAxiosError } from '../../utility/axiosErrorHandler';

export const fetchParentTimetable = createAsyncThunk<
  IParentTimetableResponse,
  { studentId: string; params?: IParentTimetableQueryParams },
  { rejectValue: IErrorResponse }
>('parentTimetable/fetch', async ({ studentId, params }, { rejectWithValue }) => {
  try {
    const response = await parentTimetableService.fetchParentTimetable(studentId, params);
    return response.data;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to fetch the timetable.'));
  }
});

export const parentTimetableActions = {
  fetchParentTimetable,
};
